import { isRetailer } from 'core/api/user';

export const worksWithSourcingFilter = {
  isAvailable: ({ user } = {}) => isRetailer(user),
  key: 'alkemics.recipients.works_with_sourcing',
  query: 'workswithsourcing',
};
